"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = exports.apiStatus = exports.statusModal = exports.userData = void 0;
const types_1 = require("./types");
exports.userData = {
    parentId: '',
    departmentId: '',
    departmentCode: '',
    departmentName: '',
    unitId: '',
    unitName: '',
    userId: ''
};
exports.statusModal = {
    isOpen: false,
    statusModalType: types_1.StatusModalTypes.SUCCESS,
    customMessage: '',
    customNote: ''
};
exports.apiStatus = {
    failed: false,
    pending: false,
    type: '',
    code: 0
};
exports.initialState = {
    globalStyle: {
        lineHeight: 'loose',
        fontSize: 'medium',
        themeColor: 'normal'
    },
    sidebarStatus: {
        isOpen: false
    },
    statusModal: exports.statusModal,
    apiStatus: exports.apiStatus
};
